module.exports = __webpack_public_path__ + "img/times.18732a52.svg";